import ExpenseTable from "pages/expense/components/ExpenseTable";

export default function FinanceExpensePage() {
  return (
    <>
      <h2 className="text-lg font-medium text-gray-900 mb-4">Expense</h2>
      <ExpenseTable />
    </>
  );
}
